<template lang="pug">
.table-editor(:class="{ 'is-resizing': resizingCol >= 0 }")
    template(v-if="edit")
        .et-toolbar-wrap
            .et-toolbar
                .et-toolbar-group
                    el-tooltip(content="Spalte links einfügen" placement="top")
                        el-button(size="mini" icon="el-icon-fa-arrow-left fas" @click="addColBefore")
                    el-tooltip(content="Spalte rechts einfügen" placement="top")
                        el-button(size="mini" icon="el-icon-fa-arrow-right fas" @click="addColAfter")
                    el-tooltip(content="Spalte löschen" placement="top")
                        el-button(size="mini" type="danger" icon="el-icon-fa-trash-alt far" @click="removeCol" :disabled="colCount <= 1")
                .et-toolbar-sep
                .et-toolbar-group
                    el-tooltip(content="Zeile oben einfügen" placement="top")
                        el-button(size="mini" icon="el-icon-fa-arrow-up fas" @click="addRowAbove")
                    el-tooltip(content="Zeile unten einfügen" placement="top")
                        el-button(size="mini" icon="el-icon-fa-arrow-down fas" @click="addRowBelow")
                    el-tooltip(content="Zeile löschen" placement="top")
                        el-button(size="mini" type="danger" icon="el-icon-fa-trash-alt far" @click="removeCurrentRow" :disabled="rows.length <= 1")
                .et-toolbar-sep
                .et-header-toggle
                    el-checkbox(v-model="hasHeader" size="mini" @change="onHeaderChange") Kopfzeile
                    .et-border-color-wrap(v-if="hasHeader")
                        button.et-border-color-btn(
                            :style="{ background: tableHeaderBg }"
                            @click="showBorderColorPicker = false; showBgColorPicker = false; showZebraColorPicker = false; showHeaderBgPicker = !showHeaderBgPicker"
                        )
                        .et-border-color-picker(v-if="showHeaderBgPicker")
                            button.et-bc-swatch(
                                v-for="c in headerBgOptions"
                                :key="c"
                                :style="{ background: c }"
                                :class="{ 'is-selected': tableHeaderBg === c }"
                                :title="c"
                                @click="pushHistory(); tableHeaderBg = c; emitChange(); showHeaderBgPicker = false"
                            )
                .et-toolbar-sep
                .et-toolbar-group
                    el-tooltip(content="Rückgängig (Strg+Z)" placement="top")
                        el-button(size="mini" icon="el-icon-fa-undo fas" @click="undo" :disabled="historyIndex <= 0")
                    el-tooltip(content="Wiederholen (Strg+Y)" placement="top")
                        el-button(size="mini" icon="el-icon-fa-redo fas" @click="redo" :disabled="historyIndex >= history.length - 1")
                .et-toolbar-info
                    span {{ rows.length }} Zeilen &times; {{ colCount }} Spalten
                el-button.et-info-btn(size="mini" type="primary" plain :class="{ 'is-active': showInfo }" @click="showInfo = !showInfo")
                    i.el-icon-fa-question-circle.fas
                    | &nbsp;Hilfe &amp; Anleitung
            .et-toolbar.et-toolbar-design
                .et-toolbar-group.et-design-group
                    span.et-design-label Tabellenbreite
                    input.et-design-input(
                        v-model="tableWidth"
                        placeholder="100%"
                        @change="emitChange"
                        @keydown.enter.prevent="$event.target.blur()"
                    )
                    template(v-if="tableWidth !== '100%'")
                        .et-border-group
                            button.et-border-btn(:class="{ 'is-on': tableAlign === 'left' }" @click="pushHistory(); tableAlign = 'left'; emitChange()" title="Links")
                                i.el-icon-fa-align-left.fas
                            button.et-border-btn(:class="{ 'is-on': tableAlign === 'center' }" @click="pushHistory(); tableAlign = 'center'; emitChange()" title="Mitte")
                                i.el-icon-fa-align-center.fas
                            button.et-border-btn(:class="{ 'is-on': tableAlign === 'right' }" @click="pushHistory(); tableAlign = 'right'; emitChange()" title="Rechts")
                                i.el-icon-fa-align-right.fas
                    .et-design-divider
                    span.et-design-label Zebra-Optik
                    button.et-design-toggle(
                        :class="{ 'is-on': tableZebra }"
                        @click="pushHistory(); tableZebra = !tableZebra; emitChange()"
                    ) {{ tableZebra ? 'An' : 'Aus' }}
                    template(v-if="tableZebra")
                        .et-border-color-wrap
                            button.et-border-color-btn(
                                :style="{ background: tableZebraColor }"
                                @click="showBorderColorPicker = false; showBgColorPicker = false; showZebraColorPicker = !showZebraColorPicker; showHeaderBgPicker = false"
                            )
                            .et-border-color-picker(v-if="showZebraColorPicker")
                                button.et-bc-swatch(
                                    v-for="c in zebraColorOptions"
                                    :key="c"
                                    :style="{ background: c }"
                                    :class="{ 'is-selected': tableZebraColor === c }"
                                    :title="c"
                                    @click="pushHistory(); tableZebraColor = c; emitChange(); showZebraColorPicker = false"
                                )
                    .et-design-divider
                    span.et-design-label Rahmen
                    .et-border-group
                        button.et-border-btn(:class="{ 'is-on': tableBorder === 'none' }" @click="pushHistory(); tableBorder = 'none'; emitChange()") Kein
                        button.et-border-btn(:class="{ 'is-on': tableBorder === 'rows' }" @click="pushHistory(); tableBorder = 'rows'; emitChange()") Zeilen
                        button.et-border-btn(:class="{ 'is-on': tableBorder === 'full' }" @click="pushHistory(); tableBorder = 'full'; emitChange()") Voll
                    .et-design-divider
                    span.et-design-label Rahmenfarbe
                    .et-border-color-wrap
                        button.et-border-color-btn(
                            :style="{ background: tableBorderColor }"
                            @click="showBgColorPicker = false; showBorderColorPicker = !showBorderColorPicker; showZebraColorPicker = false; showHeaderBgPicker = false"
                        )
                        .et-border-color-picker(v-if="showBorderColorPicker")
                            button.et-bc-swatch(
                                v-for="c in borderColors"
                                :key="c"
                                :style="{ background: c }"
                                :class="{ 'is-selected': tableBorderColor === c }"
                                :title="c"
                                @click="pushHistory(); tableBorderColor = c; emitChange(); showBorderColorPicker = false"
                            )
                    .et-design-divider
                    span.et-design-label Hintergrund
                    .et-border-color-wrap
                        button.et-border-color-btn.et-bg-color-btn(
                            :style="tableBgColor ? { background: tableBgColor } : { background: 'repeating-conic-gradient(#e5e7eb 0% 25%, #fff 0% 50%) 0 0 / 8px 8px' }"
                            @click="showBorderColorPicker = false; showZebraColorPicker = false; showBgColorPicker = !showBgColorPicker"
                        )
                        .et-border-color-picker(v-if="showBgColorPicker")
                            button.et-bc-swatch(
                                v-for="c in bgColorOptions"
                                :key="c || 'transparent'"
                                :style="c ? { background: c } : { background: 'repeating-conic-gradient(#e5e7eb 0% 25%, #fff 0% 50%) 0 0 / 8px 8px' }"
                                :class="{ 'is-selected': tableBgColor === c }"
                                :title="c || 'Transparent'"
                                @click="pushHistory(); tableBgColor = c; emitChange(); showBgColorPicker = false"
                            )

        transition(name="et-info-slide")
            .et-info-content(v-if="showInfo")
                button.et-info-close(@click="showInfo = false")
                    i.el-icon-close
                h4 Tabelleneditor — Übersicht
                .et-info-grid
                    .et-info-section
                        .et-info-title
                            i.el-icon-fa-pencil-alt.fas
                            | &nbsp;Bearbeiten
                        ul
                            li Zelle anklicken zum Bearbeiten
                            li
                                kbd Tab
                                |  /&nbsp;
                                kbd Shift+Tab
                                |  — nächste / vorherige Zelle
                            li
                                kbd Enter
                                |  — eine Zeile nach unten
                            li
                                kbd Pfeiltasten
                                |  — in alle Richtungen navigieren
                            li
                                kbd Shift
                                |  + Pfeiltasten — Auswahl erweitern
                    .et-info-section
                        .et-info-title
                            i.el-icon-fa-paint-brush.fas
                            | &nbsp;Formatierung
                        ul
                            li Zelle aktiv → Formatierungsleiste erscheint
                            li Fett, Kursiv, Links / Zentriert / Rechts
                            li Text- und Hintergrundfarbe pro Zelle
                            li Mehrere Zellen markieren → Formatierung auf alle anwenden
                    .et-info-section
                        .et-info-title
                            i.el-icon-fa-arrows-alt.fas
                            | &nbsp;Struktur &amp; Spalten/Zeilen
                        ul
                            li
                                b Pfeile in der Toolbar:
                                |  ← → fügen eine neue Spalte links/rechts der aktiven Zelle ein, ↑ ↓ eine neue Zeile darüber/darunter — einfach in eine Zelle klicken und dann den gewünschten Pfeil drücken
                            li Das rote Papierkorb-Symbol löscht die aktive Spalte oder Zeile
                            li Zeilen per Drag &amp; Drop (&#9776; am linken Rand) verschieben
                            li Spalten per Drag &amp; Drop am oberen Spalten-Header verschieben
                            li Spaltenbreite durch Ziehen am rechten Rand der Spaltenüberschrift anpassen
                            li Breite auch manuell eingeben: Klick auf den angezeigten Wert (z.B.&nbsp;
                                code 150px
                                | &nbsp;oder&nbsp;
                                code 50%
                                | ) — leer lassen für automatische Breite
                    .et-info-section
                        .et-info-title
                            i.el-icon-fa-sliders-h.fas
                            | &nbsp;Design-Optionen
                        ul
                            li
                                b Tabellenbreite:
                                |  z.B.&nbsp;
                                code 100%
                                | ,&nbsp;
                                code 600px
                                | &nbsp;oder&nbsp;
                                code 80%
                                |  — leer lassen für automatische Breite
                            li
                                b Ausrichtung:
                                |  Erscheint sobald die Breite nicht&nbsp;
                                code 100%
                                |  ist — Tabelle links, mittig oder rechts ausrichten
                            li
                                b Zebra-Optik:
                                |  Jede zweite Zeile wird eingefärbt — das Farbfeld daneben erscheint wenn Zebra aktiv ist
                            li
                                b Rahmen:
                                |&nbsp;
                                b Kein
                                |  = kein Rahmen,&nbsp;
                                b Zeilen
                                |  = horizontale Trennlinien,&nbsp;
                                b Voll
                                |  = alle Zellen mit Rahmen
                            li
                                b Rahmenfarbe:
                                |  Farbe der Tabellenlinien — Klick auf den Farbblock öffnet die Auswahl
                            li
                                b Hintergrund:
                                |  Hintergrundfarbe der Tabellenzellen (Standard: Weiß)
                            li Alle Design-Einstellungen werden beim Speichern übernommen und sind direkt im Editor sichtbar
                    .et-info-section
                        .et-info-title
                            i.el-icon-fa-paste.fas
                            | &nbsp;Import aus Excel / Google Sheets
                        ul
                            li Daten aus Excel oder Google Sheets kopieren und mit&nbsp;
                                kbd Strg+V
                                | &nbsp;direkt einfügen
                            li Die Tabelle wird automatisch erweitert falls nötig
                    .et-info-section
                        .et-info-title
                            i.el-icon-fa-history.fas
                            | &nbsp;Verlauf / Rückgängig
                        ul
                            li
                                kbd Strg+Z
                                |  — Rückgängig (bis zu 50 Schritte)
                            li
                                kbd Strg+Y
                                |  /&nbsp;
                                kbd Strg+Shift+Z
                                |  — Wiederholen

        //- Sticky bar — appears when toolbar scrolled out of view
        .et-sticky-bar(v-if="stickyVisible")
            .et-sticky-fmt(v-if="activeRow >= 0")
                span.fmt-sel-info(v-if="selectionSize > 1") {{ selectionSize }} Zellen
                .fmt-sep(v-if="selectionSize > 1")
                button.fmt-btn(:class="{ 'is-on': anchorCell && anchorCell.bold }" @click="toggleBoldSel" title="Fett")
                    b B
                button.fmt-btn(:class="{ 'is-on': anchorCell && anchorCell.italic }" @click="toggleItalicSel" title="Kursiv")
                    i I
                .fmt-sep
                button.fmt-btn(:class="{ 'is-on': anchorCell && (anchorCell.align || 'left') === 'left' }" @click="setAlignSel('left')" title="Links")
                    svg(xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="currentColor")
                        rect(x="3" y="5"  width="18" height="2" rx="1")
                        rect(x="3" y="11" width="12" height="2" rx="1")
                        rect(x="3" y="17" width="15" height="2" rx="1")
                button.fmt-btn(:class="{ 'is-on': anchorCell && anchorCell.align === 'center' }" @click="setAlignSel('center')" title="Mitte")
                    svg(xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="currentColor")
                        rect(x="3" y="5"  width="18" height="2" rx="1")
                        rect(x="6" y="11" width="12" height="2" rx="1")
                        rect(x="4" y="17" width="16" height="2" rx="1")
                button.fmt-btn(:class="{ 'is-on': anchorCell && anchorCell.align === 'right' }" @click="setAlignSel('right')" title="Rechts")
                    svg(xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="currentColor")
                        rect(x="3" y="5"  width="18" height="2" rx="1")
                        rect(x="9" y="11" width="12" height="2" rx="1")
                        rect(x="6" y="17" width="15" height="2" rx="1")
                .fmt-sep
                button.fmt-btn.fmt-color-btn(
                    :class="{ 'is-on': openColorMode === 'text' }"
                    title="Textfarbe"
                    @click="toggleColorPicker('text')"
                )
                    span.fmt-color-label(:style="{ borderBottomColor: (anchorCell && anchorCell.color) || '#303133' }") A
                button.fmt-btn.fmt-color-btn(
                    :class="{ 'is-on': openColorMode === 'bg' }"
                    title="Hintergrundfarbe"
                    @click="toggleColorPicker('bg')"
                )
                    span.fmt-bg-preview(:style="{ background: (anchorCell && anchorCell.bgColor) || 'transparent', borderColor: (anchorCell && anchorCell.bgColor) ? 'transparent' : '#aaa' }")
                .fmt-palette-wrap(v-if="openColorMode")
                    .fmt-palette
                        button.palette-swatch(
                            v-for="c in (openColorMode === 'text' ? textColors : bgColors)"
                            :key="c || 'none'"
                            :class="{ 'is-selected': openColorMode === 'text' ? (anchorCell && anchorCell.color === c) : (anchorCell && anchorCell.bgColor === c) }"
                            :style="swatchStyle(c)"
                            :title="c || 'Standard'"
                            @click="openColorMode === 'text' ? setTextColorSel(c) : setBgColorSel(c)"
                        )
                .fmt-sep
                button.fmt-btn(
                    :class="{ 'is-on': showLinkPopover, 'is-linked': anchorCell && anchorCell.link }"
                    title="Link einfügen / bearbeiten"
                    @click="toggleLinkPopover"
                )
                    i.el-icon-fa-link.fas
                .fmt-link-wrap(v-if="showLinkPopover")
                    input.fmt-link-input(
                        ref="stickyLinkInput"
                        v-model="linkPopoverHref"
                        placeholder="https://..."
                        @keydown.enter.prevent="applyLink"
                        @keydown.esc.prevent="showLinkPopover = false"
                    )
                    label.fmt-link-target-row
                        input(type="checkbox" v-model="linkPopoverTarget")
                        |  In neuem Tab öffnen
                    .fmt-link-actions
                        button.fmt-link-apply(@click="applyLink") Übernehmen
                        button.fmt-link-remove(v-if="anchorCell && anchorCell.link" @click="removeLink") Entfernen
                .et-sticky-vsep
            .et-toolbar-group
                el-tooltip(content="Spalte links einfügen" placement="top")
                    el-button(size="mini" icon="el-icon-fa-arrow-left fas" @click="addColBefore")
                el-tooltip(content="Spalte rechts einfügen" placement="top")
                    el-button(size="mini" icon="el-icon-fa-arrow-right fas" @click="addColAfter")
                el-tooltip(content="Spalte löschen" placement="top")
                    el-button(size="mini" type="danger" icon="el-icon-fa-trash-alt far" @click="removeCol" :disabled="colCount <= 1")
            .et-toolbar-sep
            .et-toolbar-group
                el-tooltip(content="Zeile oben einfügen" placement="top")
                    el-button(size="mini" icon="el-icon-fa-arrow-up fas" @click="addRowAbove")
                el-tooltip(content="Zeile unten einfügen" placement="top")
                    el-button(size="mini" icon="el-icon-fa-arrow-down fas" @click="addRowBelow")
                el-tooltip(content="Zeile löschen" placement="top")
                    el-button(size="mini" type="danger" icon="el-icon-fa-trash-alt far" @click="removeCurrentRow" :disabled="rows.length <= 1")
            .et-toolbar-info
                span {{ rows.length }} &times; {{ colCount }}

        //- Formatting bar — always visible when a cell is active
        transition(name="fmt-bar-fade")
            .et-fmt-bar(v-if="activeRow >= 0")
                span.fmt-sel-info(v-if="selectionSize > 1") {{ selectionSize }} Zellen
                .fmt-sep(v-if="selectionSize > 1")
                button.fmt-btn(:class="{ 'is-on': anchorCell && anchorCell.bold }" @click="toggleBoldSel" title="Fett")
                    b B
                button.fmt-btn(:class="{ 'is-on': anchorCell && anchorCell.italic }" @click="toggleItalicSel" title="Kursiv")
                    i I
                .fmt-sep
                button.fmt-btn(:class="{ 'is-on': anchorCell && (anchorCell.align || 'left') === 'left' }" @click="setAlignSel('left')" title="Links")
                    svg(xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="currentColor")
                        rect(x="3" y="5"  width="18" height="2" rx="1")
                        rect(x="3" y="11" width="12" height="2" rx="1")
                        rect(x="3" y="17" width="15" height="2" rx="1")
                button.fmt-btn(:class="{ 'is-on': anchorCell && anchorCell.align === 'center' }" @click="setAlignSel('center')" title="Mitte")
                    svg(xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="currentColor")
                        rect(x="3" y="5"  width="18" height="2" rx="1")
                        rect(x="6" y="11" width="12" height="2" rx="1")
                        rect(x="4" y="17" width="16" height="2" rx="1")
                button.fmt-btn(:class="{ 'is-on': anchorCell && anchorCell.align === 'right' }" @click="setAlignSel('right')" title="Rechts")
                    svg(xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="currentColor")
                        rect(x="3" y="5"  width="18" height="2" rx="1")
                        rect(x="9" y="11" width="12" height="2" rx="1")
                        rect(x="6" y="17" width="15" height="2" rx="1")
                .fmt-sep
                //- Text color
                button.fmt-btn.fmt-color-btn(
                    :class="{ 'is-on': openColorMode === 'text' }"
                    title="Textfarbe"
                    @click="toggleColorPicker('text')"
                )
                    span.fmt-color-label(:style="{ borderBottomColor: (anchorCell && anchorCell.color) || '#303133' }") A
                //- BG color
                button.fmt-btn.fmt-color-btn(
                    :class="{ 'is-on': openColorMode === 'bg' }"
                    title="Hintergrundfarbe"
                    @click="toggleColorPicker('bg')"
                )
                    span.fmt-bg-preview(:style="{ background: (anchorCell && anchorCell.bgColor) || 'transparent', borderColor: (anchorCell && anchorCell.bgColor) ? 'transparent' : '#aaa' }")
                //- Color palettes
                .fmt-palette-wrap(v-if="openColorMode")
                    .fmt-palette
                        button.palette-swatch(
                            v-for="c in (openColorMode === 'text' ? textColors : bgColors)"
                            :key="c || 'none'"
                            :class="{ 'is-selected': openColorMode === 'text' ? (anchorCell && anchorCell.color === c) : (anchorCell && anchorCell.bgColor === c) }"
                            :style="swatchStyle(c)"
                            :title="c || 'Standard'"
                            @click="openColorMode === 'text' ? setTextColorSel(c) : setBgColorSel(c)"
                        )
                .fmt-sep
                //- Link
                button.fmt-btn(
                    :class="{ 'is-on': showLinkPopover, 'is-linked': anchorCell && anchorCell.link }"
                    title="Link einfügen / bearbeiten"
                    @click="toggleLinkPopover"
                )
                    i.el-icon-fa-link.fas
                //- Link popover
                .fmt-link-wrap(v-if="showLinkPopover")
                    input.fmt-link-input(
                        ref="linkInput"
                        v-model="linkPopoverHref"
                        placeholder="https://..."
                        @keydown.enter.prevent="applyLink"
                        @keydown.esc.prevent="showLinkPopover = false"
                    )
                    label.fmt-link-target-row
                        input(type="checkbox" v-model="linkPopoverTarget")
                        |  In neuem Tab öffnen
                    .fmt-link-actions
                        button.fmt-link-apply(@click="applyLink") Übernehmen
                        button.fmt-link-remove(v-if="anchorCell && anchorCell.link" @click="removeLink") Entfernen

        .et-scroll
            table.et-table(
                :class="[`tbl-border-${tableBorder}`, { 'tbl-zebra': tableZebra }]"
                :style="{ width: tableWidth || undefined, '--tv2-border-color': tableBorderColor, '--tv2-bg-color': tableBgColor, '--tv2-zebra-color': tableZebraColor, '--tv2-header-bg': tableHeaderBg, marginLeft: tableAlign === 'right' || tableAlign === 'center' ? 'auto' : undefined, marginRight: tableAlign === 'left' || tableAlign === 'center' ? 'auto' : undefined }"
            )
                colgroup
                    col(style="width:22px;min-width:22px")
                    col(
                        v-for="(w, ci) in colWidths"
                        :key="ci"
                        :style="w ? { width: w, minWidth: '40px' } : { minWidth: '80px' }"
                    )
                thead
                    tr.et-col-handles
                        th.et-corner
                        th.et-col-handle(
                            v-for="(_, ci) in (rows[0] ? rows[0].cells : [])"
                            :key="ci"
                            draggable="true"
                            :class="{ 'is-drag-over': colDragOver === ci, 'is-dragging': colDragging === ci }"
                            @dragstart="onColDragStart(ci, $event)"
                            @dragover.prevent="onColDragOver(ci)"
                            @dragleave="colDragOver = -1"
                            @drop.prevent="onColDrop(ci)"
                            @dragend="onColDragEnd"
                        )
                            .et-col-handle-inner
                                svg.drag-dots(
                                    xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14"
                                )
                                    circle(cx="2" cy="2"  r="1.2")
                                    circle(cx="6" cy="2"  r="1.2")
                                    circle(cx="2" cy="7"  r="1.2")
                                    circle(cx="6" cy="7"  r="1.2")
                                    circle(cx="2" cy="12" r="1.2")
                                    circle(cx="6" cy="12" r="1.2")
                                span {{ ci + 1 }}
                                input.et-col-width-input(
                                    v-if="editingColWidth === ci"
                                    :ref="`cw-${ci}`"
                                    :value="editingColWidthVal"
                                    placeholder="auto"
                                    @input="editingColWidthVal = $event.target.value"
                                    @keydown.enter.prevent="confirmColWidth(ci)"
                                    @keydown.esc.prevent="editingColWidth = -1"
                                    @blur="confirmColWidth(ci)"
                                    @click.stop
                                    @mousedown.stop
                                )
                                span.et-col-width-hint(
                                    v-else
                                    :class="{ 'is-auto': !colWidths[ci] }"
                                    @click.stop="startEditColWidth(ci)"
                                    @mousedown.stop
                                ) {{ colWidths[ci] || 'auto' }}
                            .et-resize-grip(
                                draggable="false"
                                :class="{ 'is-active': resizingCol === ci }"
                                @mousedown.stop.prevent="onResizeStart(ci, $event)"
                            )

                    tr(v-if="hasHeader && rows.length > 0")
                        th.et-row-handle-cell
                        th.et-cell(
                            v-for="(cell, ci) in rows[0].cells"
                            :key="ci"
                            :class="cellClass(0, ci)"
                            :style="cellStyle(cell)"
                            @mousedown="onCellMouseDown(0, ci, $event)"
                            @mouseenter="onCellMouseEnter(0, ci)"
                        )
                            input.et-input(
                                :ref="`c-0-${ci}`"
                                :value="cell.content"
                                :style="cellInputStyle(cell)"
                                @input="setCellContent(0, ci, $event.target.value)"
                                @focus="onInputFocus(0, ci)"
                                @blur="onCellBlur"
                                @keydown="handleKeyDown($event, 0, ci)"
                                @paste.prevent="onPaste(0, ci, $event)"
                            )

                draggable(
                    v-model="bodyRows"
                    tag="tbody"
                    handle=".et-row-handle"
                    :animation="150"
                    ghost-class="et-row-ghost"
                    @end="emitChange"
                )
                    tr(v-for="(row, bodyIdx) in bodyRows" :key="row.id")
                        td.et-row-handle-cell
                            .et-row-handle
                                svg.drag-dots(xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14")
                                    circle(cx="2" cy="2"  r="1.2")
                                    circle(cx="6" cy="2"  r="1.2")
                                    circle(cx="2" cy="7"  r="1.2")
                                    circle(cx="6" cy="7"  r="1.2")
                                    circle(cx="2" cy="12" r="1.2")
                                    circle(cx="6" cy="12" r="1.2")
                        td.et-cell(
                            v-for="(cell, ci) in row.cells"
                            :key="ci"
                            :class="cellClass(actualRowIdx(bodyIdx), ci)"
                            :style="cellStyle(cell)"
                            @mousedown="onCellMouseDown(actualRowIdx(bodyIdx), ci, $event)"
                            @mouseenter="onCellMouseEnter(actualRowIdx(bodyIdx), ci)"
                        )
                            input.et-input(
                                :ref="`c-${actualRowIdx(bodyIdx)}-${ci}`"
                                :value="cell.content"
                                :style="cellInputStyle(cell)"
                                @input="setCellContent(actualRowIdx(bodyIdx), ci, $event.target.value)"
                                @focus="onInputFocus(actualRowIdx(bodyIdx), ci)"
                                @blur="onCellBlur"
                                @keydown="handleKeyDown($event, actualRowIdx(bodyIdx), ci)"
                                @paste.prevent="onPaste(actualRowIdx(bodyIdx), ci, $event)"
                            )

    .et-preview(v-else v-html="value")
    el-dialog(
        title="Tabelle anlegen"
        :visible.sync="showSetupDialog"
        width="360px"
        :close-on-click-modal="false"
        append-to-body
        custom-class="et-setup-dialog"
        @close="onSetupClose"
    )
        p.et-setup-intro Wie viele Spalten und Zeilen soll die Tabelle haben? Du kannst später jederzeit weitere hinzufügen oder entfernen.
        .et-setup-form
            .et-setup-field
                label.et-setup-label Spalten
                el-input-number(v-model="setupCols" :min="1" :max="20" size="small" controls-position="right")
            .et-setup-field
                label.et-setup-label Zeilen
                el-input-number(v-model="setupRows" :min="1" :max="50" size="small" controls-position="right")
        span.et-setup-footer(slot="footer")
            el-button(size="small" type="primary" @click="createTableFromSetup") Tabelle anlegen
</template>

<script>
import draggable from 'vuedraggable'

let _idCounter = 0
function newId() { return `r${++_idCounter}` }

const TEXT_COLORS = [null, '#000000', '#374151', '#6b7280', '#ffffff', '#ef4444', '#f97316', '#eab308', '#22c55e', '#06b6d4', '#3b82f6', '#8b5cf6', '#ec4899']
const BG_COLORS   = [null, '#fef2f2', '#fff7ed', '#fefce8', '#f0fdf4', '#ecfeff', '#eff6ff', '#faf5ff', '#fdf2f8', '#f3f4f6', '#e5e7eb', '#374151', '#000000']

export default {
    name: 'TableEditor',
    model: { prop: 'value', event: 'input' },
    components: { draggable },
    props: {
        value: { type: String, default: '' },
        edit: { type: Boolean, default: false },
    },
    data() {
        return {
            rows: [{ id: newId(), cells: [this._emptyCell()] }],
            hasHeader: false,
            colWidths: [null],
            // selection
            activeRow: -1,
            activeCol: -1,
            selEndRow: -1,
            selEndCol: -1,
            isSelecting: false,
            // design
            tableWidth: '100%',
            tableZebra: false,
            tableZebraColor: '#f3f4f6',
            tableBorder: 'full',
            tableBorderColor: '#e5e7eb',
            tableBgColor: '#ffffff',
            tableHeaderBg: '#f3f4f6',
            tableAlign: 'left',
            // ui
            showInfo: false,
            openColorMode: null,
            generatedHtml: '',
            emitTimer: null,
            // col drag
            colDragging: -1,
            colDragOver: -1,
            colDragFrom: -1,
            // col resize
            resizingCol: -1,
            resizeStartX: 0,
            resizeStartWidth: 0,
            // col width edit
            editingColWidth: -1,
            editingColWidthVal: '',
            // border/bg/zebra color pickers
            showBorderColorPicker: false,
            showBgColorPicker: false,
            showZebraColorPicker: false,
            showHeaderBgPicker: false,
            borderColors: ['#f3f4f6', '#efefef', '#e8e8e8', '#e5e7eb', '#d1d5db', '#9ca3af', '#6b7280', '#374151', '#000000', '#bfdbfe', '#93c5fd', '#fca5a5', '#86efac', '#fde68a', '#ffffff'],
            bgColorOptions: [null, '#ffffff', '#fafafa', '#f9fafb', '#f5f5f5', '#f3f4f6', '#efefef', '#e8e8e8', '#e5e7eb', '#d1d5db', '#eff6ff', '#fef2f2', '#f0fdf4', '#fefce8', '#fdf4ff', '#dbeafe'],
            zebraColorOptions: ['#fafafa', '#f9fafb', '#f5f5f5', '#f3f4f6', '#efefef', '#e8e8e8', '#e5e7eb', '#d1d5db', '#9ca3af', '#6b7280', '#dbeafe', '#dcfce7', '#fef9c3', '#fce7f3', '#ede9fe', '#fee2e2'],
            headerBgOptions: ['#fafafa', '#f9fafb', '#f5f5f5', '#f3f4f6', '#efefef', '#e8e8e8', '#e5e7eb', '#d1d5db', '#9ca3af', '#6b7280', '#374151', '#dbeafe', '#bfdbfe', '#dcfce7', '#bbf7d0', '#fef9c3', '#fce7f3', '#f5f3ff'],
            // sticky bar
            stickyVisible: false,
            // link popover
            showLinkPopover: false,
            linkPopoverHref: '',
            linkPopoverTarget: false,
            // palettes
            textColors: TEXT_COLORS,
            bgColors: BG_COLORS,
            // undo/redo
            history: [],
            historyIndex: -1,
            typingHistoryPushed: false,
            // setup dialog (Spalten/Zeilen beim Anlegen)
            showSetupDialog: false,
            setupCols: 2,
            setupRows: 2,
        }
    },
    computed: {
        colCount() {
            return this.rows.length > 0 ? this.rows[0].cells.length : 0
        },
        bodyRows: {
            get() { return this.hasHeader ? this.rows.slice(1) : this.rows },
            set(reordered) {
                this.pushHistory()
                this.rows = this.hasHeader ? [this.rows[0], ...reordered] : reordered
                this.emitChange()
            },
        },
        selRange() {
            if (this.activeRow < 0) return null
            const er = this.selEndRow >= 0 ? this.selEndRow : this.activeRow
            const ec = this.selEndCol >= 0 ? this.selEndCol : this.activeCol
            return {
                r0: Math.min(this.activeRow, er),
                r1: Math.max(this.activeRow, er),
                c0: Math.min(this.activeCol, ec),
                c1: Math.max(this.activeCol, ec),
            }
        },
        selectionSize() {
            if (!this.selRange) return 0
            const { r0, r1, c0, c1 } = this.selRange
            return (r1 - r0 + 1) * (c1 - c0 + 1)
        },
        anchorCell() {
            if (this.activeRow < 0 || !this.rows[this.activeRow]) return null
            return this.rows[this.activeRow].cells[this.activeCol] || null
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(html) {
                if (html === this.generatedHtml) return
                this.parseHtml(html)
            },
        },
        edit: {
            immediate: true,
            handler(isEdit) {
                // Beim Anlegen (Edit-Modus, noch keine Tabelle) nach Spalten/Zeilen fragen
                if (isEdit && !this.value) {
                    this.setupCols = 2
                    this.setupRows = 2
                    this._setupDone = false
                    this.$nextTick(() => { this.showSetupDialog = true })
                }
            },
        },
    },
    mounted() {
        this._onResizeMove    = this.onResizeMove.bind(this)
        this._onResizeEnd     = this.onResizeEnd.bind(this)
        this._onSelectionEnd  = () => { this.isSelecting = false }
        this._undoRedoActive  = false
        document.addEventListener('mouseup', this._onSelectionEnd)
        this._toolbarObserver = new IntersectionObserver(
            ([entry]) => { this.stickyVisible = !entry.isIntersecting },
            { threshold: 0 }
        )
        this.$nextTick(() => {
            const wrap = this.$el.querySelector('.et-toolbar-wrap')
            if (wrap) this._toolbarObserver.observe(wrap)
        })
    },
    beforeDestroy() {
        document.removeEventListener('mousemove', this._onResizeMove)
        document.removeEventListener('mouseup',   this._onResizeEnd)
        document.removeEventListener('mouseup',   this._onSelectionEnd)
        if (this._toolbarObserver) this._toolbarObserver.disconnect()
    },
    methods: {
        // ── history ───────────────────────────────────────────────
        _snapshot() {
            return JSON.parse(JSON.stringify({ rows: this.rows, hasHeader: this.hasHeader, colWidths: this.colWidths, tableWidth: this.tableWidth, tableZebra: this.tableZebra, tableZebraColor: this.tableZebraColor, tableBorder: this.tableBorder, tableBorderColor: this.tableBorderColor, tableBgColor: this.tableBgColor, tableHeaderBg: this.tableHeaderBg, tableAlign: this.tableAlign }))
        },
        _resetHistory() {
            this.history = [this._snapshot()]
            this.historyIndex = 0
            this.typingHistoryPushed = false
        },
        pushHistory() {
            this.history = this.history.slice(0, this.historyIndex + 1)
            this.history.push(this._snapshot())
            if (this.history.length > 50) { this.history.shift() } else { this.historyIndex++ }
        },
        _restoreSnapshot(snap) {
            this.rows        = JSON.parse(JSON.stringify(snap.rows))
            this.hasHeader   = snap.hasHeader
            this.colWidths   = snap.colWidths.slice()
            this.tableWidth       = snap.tableWidth       ?? '100%'
            this.tableZebra       = snap.tableZebra       ?? false
            this.tableZebraColor  = snap.tableZebraColor  ?? '#f3f4f6'
            this.tableBorder      = snap.tableBorder      ?? 'full'
            this.tableBorderColor = snap.tableBorderColor ?? '#e5e7eb'
            this.tableBgColor     = snap.tableBgColor     ?? '#ffffff'
            this.tableHeaderBg    = snap.tableHeaderBg    ?? '#f3f4f6'
            this.tableAlign       = snap.tableAlign       ?? 'left'
        },
        undo() {
            if (this.historyIndex <= 0) return
            this.historyIndex--
            this._undoRedoActive = true
            this._restoreSnapshot(this.history[this.historyIndex])
            this.emitChange()
        },
        redo() {
            if (this.historyIndex >= this.history.length - 1) return
            this.historyIndex++
            this._undoRedoActive = true
            this._restoreSnapshot(this.history[this.historyIndex])
            this.emitChange()
        },

        // ── helpers ───────────────────────────────────────────────
        _emptyCell() {
            return { content: '', bold: false, italic: false, align: null, color: null, bgColor: null, link: null, linkTarget: false }
        },
        actualRowIdx(bodyIdx) {
            return this.hasHeader ? bodyIdx + 1 : bodyIdx
        },
        isInSelection(ri, ci) {
            if (!this.selRange) return false
            const { r0, r1, c0, c1 } = this.selRange
            return ri >= r0 && ri <= r1 && ci >= c0 && ci <= c1
        },
        cellClass(ri, ci) {
            const cell = this.rows[ri]?.cells[ci]
            return {
                'is-active':   this.activeRow === ri && this.activeCol === ci,
                'is-selected': this.isInSelection(ri, ci),
                'has-link':    !!(cell && cell.link),
            }
        },
        getSelectionCells() {
            if (!this.selRange) return []
            const { r0, r1, c0, c1 } = this.selRange
            const out = []
            for (let ri = r0; ri <= r1; ri++)
                for (let ci = c0; ci <= c1; ci++)
                    out.push({ ri, ci })
            return out
        },
        cellInputStyle(cell) {
            return {
                fontWeight: cell.bold   ? 'bold'   : '',
                fontStyle:  cell.italic ? 'italic' : '',
                textAlign:  cell.align  || '',
                color:      cell.color  || '',
            }
        },
        cellStyle(cell) {
            return cell.bgColor ? { backgroundColor: cell.bgColor } : {}
        },
        swatchStyle(color) {
            return color
                ? { background: color }
                : { background: '#fff', border: '1px solid #d1d5db' }
        },

        // ── parse / generate ──────────────────────────────────────
        parseHtml(html) {
            if (!html) {
                this.rows = [{ id: newId(), cells: [this._emptyCell()] }]
                this.hasHeader = false
                this.colWidths = [null]
                this.tableWidth = '100%'
                this.tableZebra = false
                this.tableZebraColor = '#f3f4f6'
                this.tableBorder = 'full'
                this.tableBorderColor = '#e5e7eb'
                this.tableBgColor = '#ffffff'
                this.tableHeaderBg = '#f3f4f6'
                this.tableAlign = 'left'
                return
            }
            const parser = new DOMParser()
            const doc = parser.parseFromString(html, 'text/html')
            const table = doc.querySelector('table')
            if (!table) {
                this.rows = [{ id: newId(), cells: [this._emptyCell()] }]
                this.hasHeader = false
                this.colWidths = [null]
                this.tableWidth = '100%'
                this.tableZebra = false
                this.tableZebraColor = '#f3f4f6'
                this.tableBorder = 'full'
                this.tableBorderColor = '#e5e7eb'
                this.tableBgColor = '#ffffff'
                this.tableHeaderBg = '#f3f4f6'
                this.tableAlign = 'left'
                return
            }
            // Read design settings from table element
            const tStyleAttr = table.getAttribute('style') || ''
            const twMatch = tStyleAttr.match(/width:\s*([^;]+)/)
            this.tableWidth  = twMatch ? twMatch[1].trim() : '100%'
            this.tableZebra  = table.classList.contains('tbl-zebra')
            this.tableBorder = table.classList.contains('tbl-border-rows') ? 'rows'
                : table.classList.contains('tbl-border-none') ? 'none' : 'full'
            const bcMatch  = tStyleAttr.match(/--tv2-border-color:\s*([^;]+)/)
            const bgMatch  = tStyleAttr.match(/--tv2-bg-color:\s*([^;]+)/)
            const zcMatch  = tStyleAttr.match(/--tv2-zebra-color:\s*([^;]+)/)
            const hbMatch  = tStyleAttr.match(/--tv2-header-bg:\s*([^;]+)/)
            this.tableBorderColor = bcMatch ? bcMatch[1].trim() : '#e5e7eb'
            const bgVal = bgMatch ? bgMatch[1].trim() : '#ffffff'
            this.tableBgColor = bgVal === 'transparent' ? null : bgVal
            this.tableZebraColor  = zcMatch ? zcMatch[1].trim() : '#f3f4f6'
            this.tableHeaderBg    = hbMatch ? hbMatch[1].trim() : '#f3f4f6'
            this.tableAlign = table.classList.contains('tbl-align-center') ? 'center'
                : table.classList.contains('tbl-align-right') ? 'right' : 'left'

            const cols = table.querySelectorAll('colgroup col')
            const parsedWidths = Array.from(cols).map(col => {
                const m = (col.getAttribute('style') || '').match(/width:\s*([^;]+)/)
                return m ? m[1].trim() : null
            })
            this.hasHeader = !!table.querySelector('thead')
            const parsed = []
            table.querySelectorAll('tr').forEach(tr => {
                const cells = []
                tr.querySelectorAll('th, td').forEach(el => {
                    const a = el.querySelector('a')
                    const s = el.style
                    cells.push({
                        content:    el.textContent,
                        bold:       s.fontWeight === 'bold' || s.fontWeight === '700',
                        italic:     s.fontStyle  === 'italic',
                        align:      s.textAlign  || null,
                        color:      s.color      || null,
                        bgColor:    s.backgroundColor || null,
                        link:       a ? a.getAttribute('href') : null,
                        linkTarget: a ? a.getAttribute('target') === '_blank' : false,
                    })
                })
                if (cells.length) parsed.push({ id: newId(), cells })
            })
            this.rows = parsed.length ? parsed : [{ id: newId(), cells: [this._emptyCell()] }]
            const maxCols = Math.max(...this.rows.map(r => r.cells.length))
            this.rows.forEach(row => {
                while (row.cells.length < maxCols) row.cells.push(this._emptyCell())
            })
            this.colWidths = Array.from({ length: maxCols }, (_, i) => parsedWidths[i] ?? null)
            if (this._undoRedoActive) {
                this._undoRedoActive = false
            } else {
                this._resetHistory()
            }
        },

        generateHtml() {
            if (!this.rows.length) return ''
            const tClasses = [`tbl-border-${this.tableBorder}`]
            if (this.tableZebra) tClasses.push('tbl-zebra')
            if (this.tableAlign !== 'left') tClasses.push(`tbl-align-${this.tableAlign}`)
            const tStyleParts = []
            if ((this.tableWidth || '').trim()) tStyleParts.push(`width:${this.tableWidth.trim()}`)
            if (this.tableBorderColor && this.tableBorderColor !== '#e5e7eb') tStyleParts.push(`--tv2-border-color:${this.tableBorderColor}`)
            if (this.tableBgColor === null) tStyleParts.push(`--tv2-bg-color:transparent`)
            else if (this.tableBgColor && this.tableBgColor !== '#ffffff') tStyleParts.push(`--tv2-bg-color:${this.tableBgColor}`)
            if (this.tableZebra && this.tableZebraColor && this.tableZebraColor !== '#f3f4f6') tStyleParts.push(`--tv2-zebra-color:${this.tableZebraColor}`)
            if (this.tableHeaderBg && this.tableHeaderBg !== '#f3f4f6') tStyleParts.push(`--tv2-header-bg:${this.tableHeaderBg}`)
            const tStyle = tStyleParts.join(';')
            let html = `<table class="${tClasses.join(' ')}"${tStyle ? ` style="${tStyle}"` : ''}>`
            if (this.colWidths.some(w => w !== null)) {
                html += '<colgroup>'
                this.colWidths.forEach(w => { html += w ? `<col style="width:${w}">` : '<col>' })
                html += '</colgroup>'
            }
            const renderCell = (tag, cell) => {
                const styles = []
                if (cell.bold)    styles.push('font-weight:bold')
                if (cell.italic)  styles.push('font-style:italic')
                if (cell.align)   styles.push(`text-align:${cell.align}`)
                if (cell.color)   styles.push(`color:${cell.color}`)
                if (cell.bgColor) styles.push(`background-color:${cell.bgColor}`)
                const attr = styles.length ? ` style="${styles.join(';')}"` : ''
                const inner = cell.link
                    ? `<a href="${cell.link}"${cell.linkTarget ? ' target="_blank" rel="noopener noreferrer"' : ''}>${cell.content}</a>`
                    : cell.content
                return `<${tag}${attr}>${inner}</${tag}>`
            }
            if (this.hasHeader) {
                html += '<thead><tr>'
                this.rows[0].cells.forEach(c => { html += renderCell('th', c) })
                html += '</tr></thead>'
            }
            html += '<tbody>'
            for (let ri = this.hasHeader ? 1 : 0; ri < this.rows.length; ri++) {
                html += '<tr>'
                this.rows[ri].cells.forEach(c => { html += renderCell('td', c) })
                html += '</tr>'
            }
            html += '</tbody></table>'
            return html
        },

        emitChange() {
            this.generatedHtml = this.generateHtml()
            this.$emit('input', this.generatedHtml)
        },

        // ── setup dialog (Spalten/Zeilen beim Anlegen) ────────────
        createTableFromSetup() {
            const cols = Math.max(1, Math.min(20, parseInt(this.setupCols, 10) || 2))
            const rows = Math.max(1, Math.min(50, parseInt(this.setupRows, 10) || 2))
            this._setupDone = true
            this.rows = Array.from({ length: rows }, () => ({
                id: newId(),
                cells: Array.from({ length: cols }, () => this._emptyCell()),
            }))
            this.colWidths = Array.from({ length: cols }, () => null)
            this.hasHeader = false
            this.activeRow = -1
            this.activeCol = -1
            this.showSetupDialog = false
            this._resetHistory()
            this.emitChange()
        },
        onSetupClose() {
            // Beim Schließen ohne Bestätigung Standard 2×2 anlegen
            if (!this._setupDone) this.createTableFromSetup()
        },
        scheduleEmit() {
            clearTimeout(this.emitTimer)
            this.emitTimer = setTimeout(() => {
                this.emitChange()
                this.typingHistoryPushed = false
            }, 300)
        },

        // ── cell editing ──────────────────────────────────────────
        setCellContent(ri, ci, value) {
            if (!this.typingHistoryPushed) {
                this.pushHistory()
                this.typingHistoryPushed = true
            }
            const existing = this.rows[ri].cells[ci]
            this.$set(this.rows[ri].cells, ci, { ...existing, content: value })
            this.scheduleEmit()
        },

        // ── selection-aware formatting ────────────────────────────
        applyToSelection(fn) {
            this.pushHistory()
            this.getSelectionCells().forEach(({ ri, ci }) => {
                const c = this.rows[ri].cells[ci]
                this.$set(this.rows[ri].cells, ci, fn(c))
            })
            this.emitChange()
        },
        toggleBoldSel() {
            const allBold = this.getSelectionCells().every(({ ri, ci }) => this.rows[ri].cells[ci].bold)
            this.applyToSelection(c => ({ ...c, bold: !allBold }))
        },
        toggleItalicSel() {
            const allItalic = this.getSelectionCells().every(({ ri, ci }) => this.rows[ri].cells[ci].italic)
            this.applyToSelection(c => ({ ...c, italic: !allItalic }))
        },
        setAlignSel(align) {
            const allSame = this.getSelectionCells().every(({ ri, ci }) => (this.rows[ri].cells[ci].align || 'left') === align)
            this.applyToSelection(c => ({ ...c, align: allSame ? null : align }))
        },
        setTextColorSel(color) {
            this.applyToSelection(c => ({ ...c, color }))
            this.openColorMode = null
        },
        setBgColorSel(color) {
            this.applyToSelection(c => ({ ...c, bgColor: color }))
            this.openColorMode = null
        },
        toggleColorPicker(mode) {
            this.showLinkPopover = false
            this.showBorderColorPicker = false
            this.openColorMode = this.openColorMode === mode ? null : mode
        },
        toggleLinkPopover() {
            if (this.showLinkPopover) { this.showLinkPopover = false; return }
            this.openColorMode = null
            this.linkPopoverHref = (this.anchorCell && this.anchorCell.link) || ''
            this.linkPopoverTarget = (this.anchorCell && this.anchorCell.linkTarget) || false
            this.showLinkPopover = true
            this.$nextTick(() => {
                const ref = this.$refs.linkInput
                const el = Array.isArray(ref) ? ref[0] : ref
                if (el) { el.focus(); el.select() }
            })
        },
        applyLink() {
            const href = this.linkPopoverHref.trim()
            this.applyToSelection(c => ({ ...c, link: href || null, linkTarget: href ? this.linkPopoverTarget : false }))
            this.showLinkPopover = false
        },
        removeLink() {
            this.applyToSelection(c => ({ ...c, link: null, linkTarget: false }))
            this.showLinkPopover = false
        },

        // ── focus / selection state ───────────────────────────────
        onInputFocus(ri, ci) {
            this.activeRow = ri
            this.activeCol = ci
            this.selEndRow = -1
            this.selEndCol = -1
            this.openColorMode = null
            this.showLinkPopover = false
        },

        onCellMouseDown(ri, ci, event) {
            if (event.shiftKey && this.activeRow >= 0) {
                // extend selection — don't move focus
                event.preventDefault()
                this.selEndRow = ri
                this.selEndCol = ci
                this.isSelecting = true
            } else {
                // start new selection — let browser focus the input naturally
                this.selEndRow = -1
                this.selEndCol = -1
                this.isSelecting = true
                // focus input if click was outside the input itself
                if (event.target !== this.$refs[`c-${ri}-${ci}`] &&
                    !Array.isArray(this.$refs[`c-${ri}-${ci}`])) {
                    this.focusCell(ri, ci)
                }
            }
        },

        onCellMouseEnter(ri, ci) {
            if (!this.isSelecting || this.activeRow < 0) return
            this.selEndRow = ri
            this.selEndCol = ci
        },

        onCellBlur() {
            setTimeout(() => {
                const active = document.activeElement
                if (active && this.$el && this.$el.contains(active)) return
                this.activeRow = -1
                this.activeCol = -1
                this.selEndRow = -1
                this.selEndCol = -1
                this.openColorMode = null
            }, 150)
        },

        focusCell(ri, ci) {
            this.$nextTick(() => {
                const ref = this.$refs[`c-${ri}-${ci}`]
                const el = Array.isArray(ref) ? ref[0] : ref
                if (el) el.focus()
            })
        },

        onHeaderChange() {
            this.pushHistory()
            this.emitChange()
        },

        // ── row operations ────────────────────────────────────────
        addRowBelow() {
            this.pushHistory()
            const ri = this.activeRow >= 0 ? this.activeRow : this.rows.length - 1
            this.rows.splice(ri + 1, 0, { id: newId(), cells: Array.from({ length: this.colCount }, () => this._emptyCell()) })
            this.emitChange()
            this.focusCell(ri + 1, this.activeCol >= 0 ? this.activeCol : 0)
        },
        addRowAbove() {
            this.pushHistory()
            const ri = this.activeRow >= 0 ? this.activeRow : 0
            this.rows.splice(ri, 0, { id: newId(), cells: Array.from({ length: this.colCount }, () => this._emptyCell()) })
            this.emitChange()
            this.focusCell(ri, this.activeCol >= 0 ? this.activeCol : 0)
        },
        removeCurrentRow() {
            if (this.rows.length <= 1) return
            this.pushHistory()
            const ri = this.activeRow >= 0 ? this.activeRow : this.rows.length - 1
            this.rows.splice(ri, 1)
            this.activeRow = -1
            this.emitChange()
        },

        // ── column operations ─────────────────────────────────────
        addColAfter() {
            this.pushHistory()
            const ci = this.activeCol >= 0 ? this.activeCol : this.colCount - 1
            this.rows.forEach(row => row.cells.splice(ci + 1, 0, this._emptyCell()))
            this.colWidths.splice(ci + 1, 0, null)
            this.emitChange()
            this.focusCell(this.activeRow >= 0 ? this.activeRow : 0, ci + 1)
        },
        addColBefore() {
            this.pushHistory()
            const ci = this.activeCol >= 0 ? this.activeCol : 0
            this.rows.forEach(row => row.cells.splice(ci, 0, this._emptyCell()))
            this.colWidths.splice(ci, 0, null)
            this.emitChange()
        },
        removeCol() {
            if (this.colCount <= 1) return
            this.pushHistory()
            const ci = this.activeCol >= 0 ? this.activeCol : this.colCount - 1
            this.rows.forEach(row => row.cells.splice(ci, 1))
            this.colWidths.splice(ci, 1)
            this.activeCol = Math.min(ci, this.colCount - 1)
            this.emitChange()
        },
        moveColumn(fromCi, toCi) {
            if (fromCi === toCi) return
            this.pushHistory()
            this.rows.forEach(row => {
                const cell = row.cells.splice(fromCi, 1)[0]
                row.cells.splice(toCi, 0, cell)
            })
            const w = this.colWidths.splice(fromCi, 1)[0]
            this.colWidths.splice(toCi, 0, w)
            this.emitChange()
        },

        // ── column drag ───────────────────────────────────────────
        onColDragStart(ci, event) {
            this.colDragging = ci
            this.colDragFrom = ci
            event.dataTransfer.effectAllowed = 'move'
            event.dataTransfer.setData('text/plain', String(ci))
            const ghost = document.createElement('div')
            ghost.style.cssText = 'position:absolute;top:-9999px;left:-9999px;width:1px;height:1px'
            document.body.appendChild(ghost)
            event.dataTransfer.setDragImage(ghost, 0, 0)
            requestAnimationFrame(() => document.body.removeChild(ghost))
        },
        onColDragOver(ci) { this.colDragOver = ci },
        onColDrop(ci)     { this.moveColumn(this.colDragFrom, ci) },
        onColDragEnd()    { this.colDragging = -1; this.colDragOver = -1; this.colDragFrom = -1 },

        // ── column width input ────────────────────────────────────
        startEditColWidth(ci) {
            this.editingColWidth = ci
            this.editingColWidthVal = this.colWidths[ci] ? String(this.colWidths[ci]) : ''
            this.$nextTick(() => {
                const ref = this.$refs[`cw-${ci}`]
                const el = Array.isArray(ref) ? ref[0] : ref
                if (el) { el.focus(); el.select() }
            })
        },
        confirmColWidth(ci) {
            if (this.editingColWidth !== ci) return
            this.editingColWidth = -1
            const raw = this.editingColWidthVal.trim()
            let newVal = null
            if (raw !== '') {
                if (raw.endsWith('%')) {
                    const n = parseFloat(raw)
                    newVal = (!isNaN(n) && n > 0) ? Math.min(100, n) + '%' : null
                } else {
                    const n = parseInt(raw)
                    newVal = isNaN(n) ? null : Math.max(20, n) + 'px'
                }
            }
            if (newVal !== this.colWidths[ci]) {
                this.pushHistory()
                this.$set(this.colWidths, ci, newVal)
                this.emitChange()
            }
        },

        // ── column resize ─────────────────────────────────────────
        onResizeStart(ci, event) {
            this.pushHistory()
            this.resizingCol = ci
            this.resizeStartX = event.clientX
            this.isSelecting = false
            const th = this.$el.querySelectorAll('.et-col-handle')[ci]
            this.resizeStartWidth = th ? th.offsetWidth : (parseInt(this.colWidths[ci]) || 100)
            document.addEventListener('mousemove', this._onResizeMove)
            document.addEventListener('mouseup',   this._onResizeEnd)
        },
        onResizeMove(event) {
            if (this.resizingCol < 0) return
            this.$set(this.colWidths, this.resizingCol, Math.max(40, this.resizeStartWidth + event.clientX - this.resizeStartX) + 'px')
        },
        onResizeEnd() {
            if (this.resizingCol < 0) return
            this.resizingCol = -1
            document.removeEventListener('mousemove', this._onResizeMove)
            document.removeEventListener('mouseup',   this._onResizeEnd)
            this.emitChange()
        },

        // ── paste from Excel / Google Sheets ─────────────────────
        onPaste(ri, ci, event) {
            const cd = event.clipboardData
            let grid = null

            // Try HTML table first (Excel and Sheets both copy as HTML)
            const htmlData = cd.getData('text/html')
            if (htmlData) {
                const doc = new DOMParser().parseFromString(htmlData, 'text/html')
                const tbl = doc.querySelector('table')
                if (tbl) {
                    grid = []
                    tbl.querySelectorAll('tr').forEach(tr => {
                        const cells = []
                        tr.querySelectorAll('th, td').forEach(el => cells.push(el.textContent.trim()))
                        if (cells.length) grid.push(cells)
                    })
                }
            }

            // Fall back to TSV (plain text Tab-separated)
            if (!grid || !grid.length) {
                const text = cd.getData('text/plain')
                if (text) {
                    grid = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
                        .split('\n')
                        .map(line => line.split('\t'))
                        .filter(row => row.some(c => c.trim()))
                }
            }

            if (!grid || !grid.length) return

            this.pushHistory()

            // Expand rows if needed
            const neededRows = ri + grid.length
            while (this.rows.length < neededRows) {
                this.rows.push({ id: newId(), cells: Array.from({ length: this.colCount }, () => this._emptyCell()) })
            }

            // Expand columns if needed
            const neededCols = ci + Math.max(...grid.map(r => r.length))
            if (neededCols > this.colCount) {
                const toAdd = neededCols - this.colCount
                this.rows.forEach(row => {
                    for (let i = 0; i < toAdd; i++) row.cells.push(this._emptyCell())
                })
                for (let i = 0; i < toAdd; i++) this.colWidths.push(null)
            }

            // Fill cells starting at (ri, ci)
            grid.forEach((rowData, dr) => {
                rowData.forEach((cellText, dc) => {
                    const targetRi = ri + dr
                    const targetCi = ci + dc
                    const existing = this.rows[targetRi].cells[targetCi]
                    this.$set(this.rows[targetRi].cells, targetCi, { ...existing, content: cellText })
                })
            })

            this.emitChange()
            this.focusCell(ri, ci)
        },

        // ── keyboard ──────────────────────────────────────────────
        handleKeyDown(event, ri, ci) {
            const { key, shiftKey, ctrlKey, metaKey } = event
            const mod = ctrlKey || metaKey
            if (mod && key === 'z' && !shiftKey) { event.preventDefault(); this.undo(); return }
            if (mod && (key === 'y' || (key === 'z' && shiftKey))) { event.preventDefault(); this.redo(); return }
            if (key === 'Escape') {
                this.selEndRow = -1; this.selEndCol = -1; this.openColorMode = null; return
            }
            if (key === 'Tab') {
                event.preventDefault()
                this.selEndRow = -1; this.selEndCol = -1; this.openColorMode = null
                if (shiftKey) {
                    if (ci > 0) this.focusCell(ri, ci - 1)
                    else if (ri > 0) this.focusCell(ri - 1, this.colCount - 1)
                } else {
                    if (ci < this.colCount - 1) this.focusCell(ri, ci + 1)
                    else if (ri < this.rows.length - 1) this.focusCell(ri + 1, 0)
                    else this.addRowBelow()
                }
            } else if (key === 'Enter') {
                event.preventDefault()
                this.selEndRow = -1; this.selEndCol = -1; this.openColorMode = null
                if (ri < this.rows.length - 1) this.focusCell(ri + 1, ci)
                else this.addRowBelow()
            } else if (key === 'ArrowUp' || key === 'ArrowDown' || key === 'ArrowLeft' || key === 'ArrowRight') {
                const dr = key === 'ArrowUp' ? -1 : key === 'ArrowDown' ? 1 : 0
                const dc = key === 'ArrowLeft' ? -1 : key === 'ArrowRight' ? 1 : 0
                if (shiftKey) {
                    // extend selection
                    event.preventDefault()
                    const nr = Math.max(0, Math.min(this.rows.length - 1, (this.selEndRow >= 0 ? this.selEndRow : ri) + dr))
                    const nc = Math.max(0, Math.min(this.colCount - 1, (this.selEndCol >= 0 ? this.selEndCol : ci) + dc))
                    this.selEndRow = nr
                    this.selEndCol = nc
                } else {
                    // collapse and move
                    const hasSel = this.selEndRow >= 0
                    if (hasSel) {
                        event.preventDefault()
                        this.selEndRow = -1; this.selEndCol = -1
                        this.focusCell(ri, ci)
                    } else {
                        const nr = ri + dr; const nc = ci + dc
                        if (nr >= 0 && nr < this.rows.length && nc >= 0 && nc < this.colCount) {
                            event.preventDefault()
                            this.focusCell(nr, nc)
                        }
                    }
                }
            }
        },
    },
}
</script>

<style lang="sass" scoped>
.table-editor
    display: flex
    flex-direction: column
    gap: 16px
    &.is-resizing
        user-select: none
        cursor: col-resize

.et-setup-intro
    margin: 0 0 16px
    font-size: 13px
    line-height: 1.5
    color: #6b7280
.et-setup-form
    display: flex
    gap: 24px
.et-setup-field
    display: flex
    flex-direction: column
    gap: 6px
.et-setup-label
    font-size: 13px
    font-weight: 600
    color: #374151

.et-toolbar-wrap
    display: flex
    flex-direction: column
    border: 1px solid #dcdfe6
    border-radius: 4px

.et-toolbar
    display: flex
    align-items: center
    gap: 6px
    flex-wrap: nowrap
    padding: 5px 8px
    background: #f5f7fa
    border-radius: 4px 4px 0 0

.et-toolbar-design
    background: #f5f7fa
    border-top: 1px solid #e8ecf0
    padding: 4px 8px
    border-radius: 0 0 4px 4px
    position: relative

.et-toolbar-group
    display: flex
    gap: 2px

.et-header-toggle
    display: flex
    align-items: center
    gap: 6px
    .et-border-color-wrap
        position: relative

.et-toolbar-sep
    width: 1px
    height: 20px
    background: #dcdfe6
    margin: 0 4px

.et-toolbar-info
    margin-left: auto
    font-size: 11px
    color: #909399

// ── design controls (inline in toolbar) ──
.et-design-group
    align-items: center
    gap: 5px !important

.et-design-divider
    width: 1px
    height: 14px
    background: #DCDFE6
    margin: 0 2px

.et-design-label
    font-size: 11px
    color: #909399
    white-space: nowrap

.et-design-input
    width: 64px
    font-size: 12px
    border: 1px solid #DCDFE6
    border-radius: 3px
    padding: 2px 6px
    color: #303133
    background: #fff
    outline: none
    &:focus
        border-color: $--color-primary

.et-design-toggle
    font-size: 11px
    padding: 2px 10px
    border: 1px solid #DCDFE6
    border-radius: 3px
    background: #fff
    color: #606266
    cursor: pointer
    &.is-on
        background: #ecf5ff
        border-color: #b3d8ff
        color: $--color-primary

.et-border-color-wrap
    position: relative
    display: flex
    align-items: center

.et-border-color-btn
    width: 22px
    height: 22px
    border: 1px solid #DCDFE6
    border-radius: 3px
    cursor: pointer
    padding: 0
    flex-shrink: 0
    display: flex
    align-items: center
    justify-content: center

.et-bg-color-btn
    background: repeating-conic-gradient(#e5e7eb 0% 25%, #fff 0% 50%) 0 0 / 8px 8px
    &[style]
        background: attr(style)

.et-border-color-picker
    position: absolute
    top: calc(100% + 4px)
    left: 0
    z-index: 200
    background: #fff
    border: 1px solid #dcdfe6
    border-radius: 6px
    box-shadow: 0 4px 12px rgba(0,0,0,0.12)
    padding: 6px
    display: flex
    flex-wrap: wrap
    gap: 4px
    width: 114px

.et-bc-swatch
    width: 20px
    height: 20px
    border-radius: 3px
    border: 2px solid transparent
    cursor: pointer
    padding: 0
    flex-shrink: 0
    transition: transform 0.1s, border-color 0.1s
    box-shadow: inset 0 0 0 1px rgba(0,0,0,0.12)
    &:hover
        transform: scale(1.2)
    &.is-selected
        border-color: $--color-primary

.et-border-group
    display: flex

.et-border-btn
    font-size: 11px
    padding: 2px 8px
    border: 1px solid #DCDFE6
    background: #fff
    color: #606266
    cursor: pointer
    margin-left: -1px
    &:first-child
        border-radius: 3px 0 0 3px
        margin-left: 0
    &:last-child
        border-radius: 0 3px 3px 0
    &.is-on
        background: #ecf5ff
        border-color: #b3d8ff
        color: $--color-primary
        z-index: 1
        position: relative

// ── editor table design classes ──
.et-table
    &.tbl-zebra
        tbody tr:nth-child(even) td.et-cell
            background: var(--tv2-zebra-color, #f3f4f6)

    &.tbl-border-none
        th.et-cell,
        td.et-cell
            border-color: transparent

    &.tbl-border-rows
        th.et-cell,
        td.et-cell
            border-left-color: transparent
            border-right-color: transparent

// ── info button ──
.et-info-btn
    margin-left: 4px
    &.is-active
        background: #ecf5ff !important

// ── info panel ──
.et-info-content
    background: #f0f7ff
    border: 1px solid #c6e0ff
    border-radius: 6px
    padding: 20px 24px 18px
    font-size: 13px
    line-height: 1.7
    color: #4b5563
    position: relative

    h4
        margin: 0 0 16px
        font-size: 15px
        font-weight: 700
        color: #1e3a5f
        border-bottom: 2px solid #c6e0ff
        padding-bottom: 10px

    ul
        margin: 6px 0 0
        padding-left: 18px
        li
            margin-bottom: 5px
            font-size: 13px

    b
        color: #1e3a5f

    kbd
        display: inline-block
        padding: 2px 7px
        font-size: 12px
        font-family: monospace
        background: #fff
        border: 1px solid #DCDFE6
        border-bottom-width: 2px
        border-radius: 4px
        color: #303133
        line-height: 1.5

    code
        background: #fff
        border: 1px solid #DCDFE6
        border-radius: 3px
        padding: 2px 5px
        font-size: 12px
        color: #303133

.et-info-grid
    display: grid
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr))
    gap: 16px 32px

.et-info-section
    .et-info-title
        font-weight: 700
        color: #2563eb
        font-size: 12px
        text-transform: uppercase
        letter-spacing: 0.06em
        margin-bottom: 6px
        display: flex
        align-items: center
        gap: 5px

.et-info-close
    position: absolute
    top: 12px
    right: 14px
    background: none
    border: none
    cursor: pointer
    color: #909399
    font-size: 18px
    line-height: 1
    padding: 2px
    &:hover
        color: #303133

.et-info-slide-enter-active,
.et-info-slide-leave-active
    transition: all .2s ease

.et-info-slide-enter,
.et-info-slide-leave-to
    opacity: 0
    transform: translateY(-6px)

// ── sticky bar ──
.et-sticky-bar
    position: sticky
    top: 1px
    z-index: 50
    display: flex
    align-items: center
    gap: 4px
    padding: 5px 8px
    background: #fff
    border: 1px solid #dcdfe6
    border-radius: 0 0 4px 4px
    box-shadow: 0 3px 10px rgba(0,0,0,0.10)

.et-sticky-fmt
    display: flex
    align-items: center
    gap: 1px
    position: relative

.et-sticky-vsep
    width: 1px
    height: 20px
    background: #dcdfe6
    margin: 0 6px 0 4px
    flex-shrink: 0

// ── formatting bar ──
.et-fmt-bar
    display: flex
    align-items: center
    flex-wrap: nowrap
    gap: 1px
    padding: 3px 8px
    background: #fff
    border: 1px solid #dcdfe6
    border-radius: 4px
    position: relative

.fmt-sel-info
    font-size: 11px
    color: $--color-primary
    font-weight: 600
    padding: 0 4px

.fmt-btn
    display: inline-flex
    align-items: center
    justify-content: center
    width: 26px
    height: 24px
    border: 1px solid transparent
    border-radius: 3px
    background: transparent
    cursor: pointer
    color: #606266
    font-size: 12px
    padding: 0
    transition: all 0.1s
    flex-shrink: 0
    b, i
        font-size: 13px
        line-height: 1
    &:hover
        background: #e9edf3
        border-color: #dcdfe6
    &.is-on
        background: #ecf5ff
        border-color: $--color-primary
        color: $--color-primary

.fmt-color-btn
    width: 30px

.fmt-color-label
    font-weight: 700
    font-size: 14px
    line-height: 1
    border-bottom: 3px solid currentColor
    padding-bottom: 1px

.fmt-bg-preview
    display: block
    width: 14px
    height: 14px
    border-radius: 2px
    border: 1px solid #d1d5db
    flex-shrink: 0

.fmt-sep
    width: 1px
    height: 16px
    background: #dcdfe6
    margin: 0 4px
    flex-shrink: 0

// ── link popover ──
.fmt-link-wrap
    position: absolute
    top: calc(100% + 4px)
    right: 0
    z-index: 100
    background: #fff
    border: 1px solid #dcdfe6
    border-radius: 6px
    box-shadow: 0 4px 12px rgba(0,0,0,0.12)
    padding: 10px 12px
    min-width: 240px
    display: flex
    flex-direction: column
    gap: 8px

.fmt-link-input
    width: 100%
    font-size: 12px
    border: 1px solid #DCDFE6
    border-radius: 3px
    padding: 5px 8px
    color: #303133
    outline: none
    box-sizing: border-box
    &:focus
        border-color: $--color-primary

.fmt-link-target-row
    display: flex
    align-items: center
    gap: 6px
    font-size: 12px
    color: #606266
    cursor: pointer
    input[type="checkbox"]
        cursor: pointer

.fmt-link-actions
    display: flex
    gap: 6px

.fmt-link-apply
    flex: 1
    font-size: 12px
    padding: 4px 10px
    background: $--color-primary
    color: #fff
    border: none
    border-radius: 3px
    cursor: pointer
    &:hover
        background: darken(#409eff, 8%)

.fmt-link-remove
    font-size: 12px
    padding: 4px 10px
    background: #fff
    color: #f56c6c
    border: 1px solid #f56c6c
    border-radius: 3px
    cursor: pointer
    &:hover
        background: #fef0f0

// ── linked cell indicator ──
td.et-cell.has-link,
th.et-cell.has-link
    &::after
        content: ''
        position: absolute
        bottom: 0
        left: 0
        right: 0
        height: 2px
        background: $--color-primary
        pointer-events: none

.fmt-btn.is-linked
    color: $--color-primary

// ── color palette dropdown ──
.fmt-palette-wrap
    position: absolute
    top: calc(100% + 4px)
    left: 0
    z-index: 100
    background: #fff
    border: 1px solid #dcdfe6
    border-radius: 6px
    box-shadow: 0 4px 12px rgba(0,0,0,0.12)
    padding: 6px

.fmt-palette
    display: flex
    flex-wrap: wrap
    gap: 4px
    width: 166px

.palette-swatch
    width: 20px
    height: 20px
    border-radius: 3px
    border: 2px solid transparent
    cursor: pointer
    padding: 0
    flex-shrink: 0
    transition: transform 0.1s, border-color 0.1s
    position: relative
    &[title="Standard"]::after
        content: ''
        position: absolute
        inset: 1px
        background: linear-gradient(to bottom right, transparent calc(50% - 1px), #ef4444 calc(50% - 1px), #ef4444 calc(50% + 1px), transparent calc(50% + 1px))
    &:hover
        transform: scale(1.2)
        border-color: #9ca3af
    &.is-selected
        border-color: $--color-primary

// ── scroll + table ──
.et-scroll
    overflow-x: auto
    border: 1px solid #dcdfe6
    border-radius: 4px

.et-table
    border-collapse: collapse
    min-width: 100%
    font-size: 13px
    table-layout: fixed
    user-select: none

    th.et-cell,
    td.et-cell
        border: 1px solid var(--tv2-border-color, #dcdfe6)
        padding: 0
        overflow: visible
        position: relative
        vertical-align: top
        cursor: cell

    th.et-cell
        background: var(--tv2-header-bg, #f5f7fa)
        font-weight: 600
    td.et-cell
        background: var(--tv2-bg-color, #ffffff)

    th.et-cell.is-active,
    td.et-cell.is-active
        border-color: $--color-primary
        box-shadow: inset 0 0 0 2px $--color-primary
        z-index: 2

    th.et-cell.is-selected:not(.is-active),
    td.et-cell.is-selected:not(.is-active)
        box-shadow: inset 0 0 0 9999px rgba(64, 158, 255, 0.10)

    th.et-cell.is-active.is-selected,
    td.et-cell.is-active.is-selected
        box-shadow: inset 0 0 0 2px $--color-primary, inset 0 0 0 9999px rgba(64, 158, 255, 0.10)

// ── row handle ──
.et-row-handle-cell
    width: 22px
    padding: 0 !important
    border: none !important
    background: transparent

.et-row-handle
    display: flex
    align-items: center
    justify-content: center
    width: 22px
    height: 100%
    min-height: 32px
    cursor: grab
    color: #c0c4cc
    transition: color 0.15s
    &:hover
        color: $--color-primary
    &:active
        cursor: grabbing

.et-row-ghost
    opacity: 0.4
    background: #ecf5ff !important

// ── col handles row ──
.et-col-handles
    .et-corner
        width: 22px
        border: none
        background: transparent
    .et-col-handle
        position: relative
        border: 1px solid #dcdfe6
        border-bottom: 2px solid #dcdfe6
        background: #eef0f4
        padding: 3px 18px 3px 6px
        cursor: grab
        user-select: none
        transition: background 0.15s
        overflow: visible
        &:hover
            background: #e0e7f0
        &.is-dragging
            cursor: grabbing
            opacity: 0.5
        &.is-drag-over
            background: #d9ecff
            border-color: $--color-primary

.et-col-handle-inner
    display: flex
    align-items: center
    gap: 4px
    font-size: 11px
    color: #606266
    overflow: hidden
    white-space: nowrap

.et-col-width-hint
    font-size: 10px
    color: #a0a8b4
    margin-left: auto
    cursor: pointer
    border-radius: 2px
    padding: 0 2px
    &:hover
        color: $--color-primary
        background: rgba(64,158,255,.08)
    &.is-auto
        opacity: 0.45
        &:hover
            opacity: 1

.et-col-width-input
    width: 44px
    font-size: 10px
    color: #303133
    background: #fff
    border: 1px solid $--color-primary
    border-radius: 3px
    padding: 1px 3px
    margin-left: auto
    outline: none
    text-align: right

.drag-dots
    fill: currentColor
    flex-shrink: 0

.et-resize-grip
    position: absolute
    right: 0
    top: 0
    bottom: 0
    width: 7px
    cursor: col-resize
    z-index: 2
    &::after
        content: ''
        position: absolute
        right: 2px
        top: 20%
        bottom: 20%
        width: 2px
        background: #c0c4cc
        border-radius: 1px
        transition: background 0.1s
    &:hover::after, &.is-active::after
        background: $--color-primary
    &:hover, &.is-active
        background: rgba($--color-primary, 0.12)

// ── cell input ──
.et-input
    display: block
    width: 100%
    border: none
    outline: none
    background: transparent
    padding: 6px 8px
    font-size: 13px
    font-family: inherit
    font-weight: inherit
    color: #303133
    box-sizing: border-box
    min-height: 32px
    user-select: text
    cursor: text
    &:focus
        background: rgba(255,255,255,0.6)

// ── fmt bar transition ──
.fmt-bar-fade-enter-active, .fmt-bar-fade-leave-active
    transition: opacity 0.15s
.fmt-bar-fade-enter, .fmt-bar-fade-leave-to
    opacity: 0

// ── preview ──
.et-preview
    ::v-deep table
        border-collapse: collapse
        width: 100%
        font-size: 13px
    ::v-deep th,
    ::v-deep td
        border: 1px solid #dcdfe6
        padding: 6px 10px
        text-align: left
    ::v-deep th
        background: var(--tv2-header-bg, #f5f7fa)
        font-weight: 600
</style>

